export const SET_EDIT_INTEGRATION_FLAG = "SET_EDIT_INTEGRATION_FLAG";
